
import $ from 'jquery'
import ActText from './inputTextSth'
import ActChoose from "./chooseSth";
import ActData from "./data";

let loadButtonListUrl = "/cm-sites-activiti/activiti/getButton";
let actSubmitUrl = "/cm-sites-activiti/activiti/submitForm";
let actButtonConfig = "/cm-sites-activiti/activitiButtonConfig/getActButtonConfig";
let actStartFromUrl = "/cm-sites-activiti/activiti/getStartFrom";
let actFromUrl = "/cm-sites-activiti/activiti/getFormUrlById";
let actGetTaskIdUrl = "/cm-sites-activiti/activitiAdmin/getTaskIdByProcessInstanceId";
let actTodoListUrl = "/cm-sites-activiti/activiti/getNeedProcessed";
let actTodoAllListUrl = "/cm-sites-activiti/activiti/getNeedProcessedAll";
let getActServiceDataByIdUrl = "/cm-sites-activiti/activiti/getActServiceDataByIdUrl";
let actExaminedUrl = "/cm-sites-activiti/activiti/examined";
let actHistoryUrl = "/cm-sites-activiti/activiti/getActHistory";
let actTaskFormUrl = "/cm-sites-activiti/activiti/getTaskForm";
let terminateUrl = "/cm-sites-activiti/activitiAdmin/terminateByProcessInstanceId";

let isStart = false;
export let clickButtonId ;
let win = window.top || window;

/** 流程公共表单 **/
let thisForm = {};
/** 用户信息以及入口按钮配置信息，业务主键id  需要业务赋值 **/
export let actData = new ActData();

let layerLoadIndexArray = [];

/** 表单数据 **/
export let actForm = {
    values:{},
    users:{},
};

/** 流程数据 **/
export let actProcess = {
    id :actData.id,
};
/** 节点数据 **/
let actTask = {
    lastId:null    //最后一个节点id，也就是当前所流转到的节点id
};

export let actButton = new ActButton();
export let actChoose = new  ActChoose();
export let actText = new  ActText();

/** 按钮列表 **/
export let actButtonList ;

/**
 * 按钮列表对象
 *  主要功能：存储按钮配置
 * @param buttonList
 * @constructor
 */
function ActButtonList(buttonList){
    //  按钮配置组
    this.buttonConfigList = buttonList || null;
    this.buttonMap = {};
    let that = this;
    $.each(buttonList,function (index,item) {
        that.buttonMap[index] = item;
    })
}

/**
 * 按钮对象
 *  主要功能：解析按钮配置，有对应的公共方法
 * @param button
 * @constructor
 */
export function ActButton(button){
    $.extend(this,button);
    this.style ={
        class:null
    }
}


ActButton.prototype.overflowAttr = function(button) {
    $.extend(this,button);
    this.style ={
        class:null
    }
};

//选择完成后执行,组装参数
ActButton.prototype.chooseDone = function(choose){
    actButton.load();
    if(choose.type == "activitiUsers" || choose.type == "users"){
        actForm.users = $.extend(actForm.users, choose);
    }else if(choose.type == "remarks"){
        actForm.values.otherData = {};
        actForm.values.otherData = {"remarks":choose.remarks};
    }
    //新流程，先自推一次
    if(actProcess.processInstanceId == undefined || actProcess.processInstanceId == null){
        //提交开始表单 获取流程id
        actButton.submitStart(function(){
            actForm.deploymentKey = actProcess.deploymentKey;
            actButton.onlySubmit();
        });
    }else{
        actButton.onlySubmit();
    }

}

/**
 * 按钮点击事件
 * @param index
 */
ActButton.prototype.buttonClick = function(index) {
    //从按钮列表中获取按钮配置
    let actButtonJson = actButtonList.buttonMap[parseInt(index)];
    //初始化当前按钮对象
    actButton.overflowAttr(actButtonJson);
    //设置表单数据中选择数据为当前按钮名称
    actForm.values.choose = actButton.name;
    if(actButton &&  actButton.document  && actButton.document.lineJavaScript ){
        let lineJavaScript = actButton.document.lineJavaScript;
        actButton.auditorMap = lineJavaScript.auditorMap;
        $.extend(actButton.auditorMap,actForm.users)
        actForm.users = actButton.auditorMap;
        // $.extend(actForm.users, actButton.auditorMap);
        //是否需要调用外部接口
        if(lineJavaScript.url != undefined && lineJavaScript.url.length > 0){
            actForm.values.url = lineJavaScript.url;
        }
        //需要选人
        if(lineJavaScript.needAuditor == true){
            actButton.needAuditor = lineJavaScript.needAuditor;
            actButton.chooseAuditor(lineJavaScript.auditorMap);
        }//需要审核意见
        else if(lineJavaScript.needRemarks == true){
            actButton.needRemarks = lineJavaScript.needRemarks;
            actText.getText({title:"备注"},"remarks",actButton.chooseDone);
        }else if(lineJavaScript.auditorMap != undefined){
            actButton.chooseDone(lineJavaScript.auditorMap);
        }else {
            //什么都不选
            actButton.onlySubmit();
        }

    }
}

ActButton.prototype.onlySubmit = function(){
    if(!isStart){
        this.afterClickButton(clickButtonId, function(id){
            if(actProcess.processInstanceId != null) {
                //获取taskId
                actButton.getTaskList(actProcess.processInstanceId,function(taskList){
                    //设置节点id
                    actTask.lastId = taskList[taskList.length -1].id;
                    //设置表单id
                    actForm.id = taskList[taskList.length -1].id;
                    //根据最后一个节点id 获取当前表单
                    actButton.getFrom(actTask.lastId,function(requestData){
                        //设置表单id
                        actForm.formId = requestData.formId;
                        //设置节点id
                        actTask.lastId = requestData.id;
                        actButton.submit();
                    });
                });
            }
        });
    }else{
        if(actProcess.processInstanceId != null) {
            //获取taskId
            actButton.getTaskList(actProcess.processInstanceId,function(taskList){
                //设置节点id
                actTask.lastId = taskList[taskList.length -1].id;
                //设置表单id
                actForm.id = taskList[taskList.length -1].id;
                //根据最后一个节点id 获取当前表单
                actButton.getFrom(actTask.lastId,function(requestData){
                    //设置表单id
                    actForm.formId = requestData.formId;
                    //设置节点id
                    actTask.lastId = requestData.id;
                    actButton.submit();
                });
            });
        }
    }

}

ActButton.prototype.getFrom = function(taskId,call){
    actButton.post(actFromUrl,{id : taskId},call);
}
ActButton.prototype.getTaskList = function(processInstanceId,call,data){
   actButton.post(actGetTaskIdUrl, {
        processInstanceId: processInstanceId
    },function(requestData){
       if(typeof call == 'function'){
           call(requestData.data,processInstanceId,data)
       }
    })
}

ActButton.prototype.submitAll = function(objects,name,call){
    actButton.loadButtonList({id: null,
        processInstanceId: objects[0].processInstanceId,
        deploymentKey: objects[0].deploymentKey
    },function(){
        //从按钮列表中获取按钮配置
        let actButtonJson ="";
        for(let key in actButtonList.buttonMap){
            if(actButtonList.buttonMap[key].name == name){
                actButtonJson = actButtonList.buttonMap[key];
            }
        }
        //初始化当前按钮对象
        actButton.overflowAttr(actButtonJson);
        for (let i = 0 ;i < objects.length ; i++){
            isStart = false;
            let lineJavaScript = actButton.document.lineJavaScript;
            //获取taskId
            actButton.getTaskList(objects[i].processInstanceId,function(taskList,processInstanceId,data){
                let myActForm = {};
                myActForm.deploymentKey = actProcess.deploymentKey;
                //设置表单数据中选择数据为当前按钮名称
                myActForm.values = {} ;
                myActForm.values.choose = actButton.name;
                myActForm.values.jsondata = {};
                myActForm.values.jsondata.serviceId = data.id;
                myActForm.values.jsondata.jsondata = data.jsondata;
                myActForm.users = lineJavaScript.auditorMap;
                myActForm.processInstanceId = processInstanceId;
                //设置节点id
                let lastId = taskList[taskList.length -1].id;
                //根据最后一个节点id 获取当前表单
                actButton.getFrom(lastId,function(requestData){
                    //设置表单id
                    myActForm.id = requestData.id;
                    //设置表单id
                    myActForm.formId = requestData.formId;
                    //设置节点id
                    actTask.lastId = requestData.id;
                    actButton.post(actSubmitUrl,JSON.stringify(myActForm),function(requestData){
                        if(requestData.status != undefined && requestData.status == 200){
                            call({type:"success",object:data});
                        }else{
                            call({type:"error",object:data});
                        }
                    });
                });
            },objects[i]);
        }
    });
}

/**
 * 获取历史
 * @param processInstanceId
 * @returns {*}
 */
ActButton.prototype.getHistory = function(call,processInstanceId){
    actButton.post(actHistoryUrl,{processInstanceId : processInstanceId || actProcess.processInstanceId},function(requestData){
        if(typeof call == 'function'){
            call(requestData);
        }
    })
}

/**
 * 提供给资源库
 */
ActButton.prototype.getHistoryByServiceId = function(buttonId,userName,serviceId,collback){
    let data = [];
    actButton.overflowAttr();
    actData.buttonId = buttonId;
    actData.userName = userName;
    actButton.getDeploymentKey(buttonId,function (requestData){
        actButton.getActServiceDataById(serviceId,function(serviceData){
            if(serviceData && serviceData._ProcessInstanceId){
                actProcess.processInstanceId = serviceData._ProcessInstanceId;
                actButton.getHistory(function(history){
                    if(history && history.data){
                        if(history.data.length > 0 ){
                            $.each(history.data,function(index,obj){
                                if(obj.task && obj.task.values && obj.task.values.jsondata){
                                    let object ={};
                                    object = JSON.parse(JSON.parse(obj.task.values.jsondata).jsondata);
                                    if(obj.assignee == undefined || obj.assignee ==  null){
                                        object.activitiAuditorNames = obj.activitiAuditorNames;
                                    }else{
                                        object.assigneeName = obj.assigneeName;
                                    }
                                    object.statusName = obj.task.values.choose;
                                    object.startTime = actButton.timeFormat(obj.startTime);
                                    data.push(object);
                                }
                            })
                        }
                    }
                });

            }
            collback(data);
        });
    });
}

/**
 * 获取表单内容
 * @param processInstanceId
 * @returns {*}
 */
ActButton.prototype.getTaskForm = function(taskId,call){
    actButton.post(actTaskFormUrl,{taskId : taskId},function(data){
        if(typeof call == 'function'){
            call(data);
        }
    })
}

ActButton.prototype.post = function(url,pram,call){
    let requestData ;
    let contentType =  'application/x-www-form-urlencoded';
    if(typeof pram == 'string'){
        contentType =  'application/json; charset=UTF-8';
    }
    $.ajax({
        url: url,
        data: pram,
        contentType: contentType,
        dataType:"JSON",
        traditional:true,
        type:"POST",
        success: function(result){
            if(typeof result == 'string'){
                if(isJsonFormat(result)){
                    requestData = JSON.parse(result);
                }else{
                    requestData = result;
                }
            }else{
                requestData = result;
            }
            if(typeof call == "function"){
                call(requestData);
            }
        },
        error:function(e){
            call(false);
            console.log(e);
        },
        beforeSend: function(xhr) {
            xhr.setRequestHeader("userName", actData.userName);
        }
    });
}

function isJsonFormat( str ) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

/**
 * 同步ajax
 */
ActButton.prototype.syncPost = function(url,pram,call){
    let win = window.top || window;
    let layerIndex = win.layer.load();
    let requestData ;
    let contentType =  'application/x-www-form-urlencoded';
    if(typeof pram == 'string'){
        contentType =  'application/json; charset=UTF-8';
    }
    $.ajax({
        url: url,
        data: pram,
        async:false,
        contentType: contentType,
        dataType:"JSON",
        type:"POST",
        success: function(result){
            if(typeof result == 'string'){
                requestData = JSON.parse(result);
            }else{
                requestData = result;
            }
        },
        error:function(e){
            console.log(e);
        },
        beforeSend: function(xhr) {
            xhr.setRequestHeader("userName", actData.userName);
        }
    });
    win.layer.close(layerIndex);
    if(typeof call == "function"){
        call(requestData);
    }else{
        return requestData;
    }
}


ActButton.prototype.postAsync = function(url,pram,callBack){
    let requestData ;
    let contentType =  'application/x-www-form-urlencoded';
    if(typeof pram == 'string'){
        contentType =  'application/json; charset=UTF-8';
    }
    $.ajax({
        url: url,
        data: pram,
        async:true,
        contentType: contentType,
        dataType:"JSON",
        type:"POST",
        success: function(result){
            if(typeof result == 'string'){
                requestData = JSON.parse(result);
            }else{
                requestData = result;
            }
            callBack(requestData);
        },
        error:function(e){
            console.log(e);
        },
        beforeSend: function(xhr) {
            xhr.setRequestHeader("userName", actData.userName);
        }
    });
}
//
// ActButton.prototype.afterClickButton = function(clickButtonId, call){
//     call();
// };


ActButton.prototype.submitStart = function(call){
    isStart = true;
    this.afterClickButton(clickButtonId, function(id){
        //获取开始表单
        actButton.post(actStartFromUrl,{
            deploymentKey: actProcess.deploymentKey
        },function(startData){
            actProcess.processDefinitionId = startData.processDefinitionId;

            //提交开始表单
            actButton.post(actSubmitUrl,JSON.stringify({
                processDefinitionId : actProcess.processDefinitionId,
                deploymentKey : actProcess.deploymentKey,
            }),function(submitData){
                //流程实例id
                actProcess.processInstanceId = submitData.id;
                actForm.processInstanceId = actProcess.processInstanceId;
                if(typeof call == 'function'){
                    call(submitData.id);
                }
            });
        });
    });
}


ActButton.prototype.submit = function(call){
    actForm.deploymentKey = actProcess.deploymentKey;
    if(actForm.users.activitiUsers && actForm.users.activitiUsers.length > 0 ){
        actForm.users.FORM_SERVICE_USERS = [];
    }
    actButton.post(actSubmitUrl,JSON.stringify(actForm),function(requestData){
        if(requestData.status != undefined && requestData.status == 200){
            actButton.end(null,function(){
                if(typeof(actButton.name) != "undefined" && actButton.name && actButton.name.length > 0 ){
                    let layerMsg = actButton.name + '成功';
                    if(actForm.values.url){
                        layerMsg = "正在" + actButton.name + "中，可以在列表页查看发布进度。"
                    }
                    actButton.alert({msg:layerMsg,state:true},actButton.submitOK);
                }else{
                    actButton.alert({msg:requestData.msg,state:true},actButton.submitOK);
                }
                //清空按钮
                //actButton.reload(actProcess.processInstanceId);
                //清空表单参数
                actForm.users={};
            })
        }else if(requestData && requestData.status != undefined && requestData.status == 500){
            actButton.closeAll();
            //提交表单失败，调用错误方法
            // actButton.submitError(requestData);
        }else if(requestData == undefined){
            actButton.closeAll();
            actButton.alert({msg:"请求超时！内容已保存，请刷新重试" ,state:false});
        }else{
            actButton.closeAll();
            actButton.alert({msg:"流程推进失败！"+requestData.msg,state:false});
        }
    });

}

// ActButton.prototype.submitError = function(data){
//     if(typeof(eval("advanceError")) == "function")
//     {
//         advanceError(data);
//     }else{
//         console.log(data.msg);
//     }
// }



ActButton.prototype.reload = function(id){
    $("#testButton").html("");
    /* if(actButton.loadButtonList({
        id:id,
        processDefinitionId:actProcess.processDefinitionId
    })){
        //加载按钮
        actButton.showButtonList();
       //加载审核意见等信息
        thisForm = actButton.gtFrom(actTask.lastId);
        thisForm.fields.forEach(function (item,index) {
            if(item.id == "otherData" && item.value.length > 0){
                let otherData = JSON.parse(item.value);
                if(otherData.hasOwnProperty("remarks")){
                    console.log("审核意见"+otherData.remarks);
                }
            }
        })
    }*/
}

//选择方法： 弹框，选择，返回
ActButton.prototype.end = function(statusName,call) {
    if(typeof(actButton.endFunction)=="function")
    {
        actButton.endFunction((data) =>{
            //如果调用的方法返回的不是对象，那么返回值会是方法本身，故无法判断方法是否正确执行，默认放行。
            // 返回对象的默认格式 {status : false || true ,msg: ""}
            if(data && data.code === 200){
                call()
            }else{
                actButton.alert("执行流程出错。提示信息:" + data.msg);
            }
        },statusName);
        return 1;
    }
    return 1;
};

ActButton.prototype.chooseAuditor = function(auditorMap) {
    //如果是业务指定的人，则优先业务的人
    if(typeof win._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS != "undefind" && $.isArray(win._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS) && win._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS.length >0)
        return actChoose.getChoose(win._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS,"activitiUsers",actButton.chooseDone);
    //如果是指定人中选一个的，则列出人的列表
    else if(auditorMap.FORM_SERVICE_USERS.length > 0){
        return actChoose.getChoose(auditorMap.FORM_SERVICE_USERS,"users",actButton.chooseDone);
    }else if(auditorMap.FORM_SERVICE_GROUP.length > 0  && auditorMap.FORM_SERVICE_ROLE.length < 1){    //只选择部门
        return actChoose.getChoose(actData.getUser({
            group:auditorMap.FORM_SERVICE_GROUP
        }),"activitiUsers",actButton.chooseDone);
    }else if(auditorMap.FORM_SERVICE_ROLE.length > 0 && auditorMap.FORM_SERVICE_GROUP.length < 1){     //只选择角色
        return actChoose.getChoose(actData.getUser({
            role :auditorMap.FORM_SERVICE_ROLE
        }),"activitiUsers",actButton.chooseDone);
    }else if(auditorMap.FORM_SERVICE_GROUP && auditorMap.FORM_SERVICE_ROLE){      //选择角色和部门
        return actChoose.getChoose(actData.getUser({
            role :auditorMap.FORM_SERVICE_ROLE,
            group :auditorMap.FORM_SERVICE_GROUP
        }),"activitiUsers",actButton.chooseDone);
    }
};

ActButton.prototype.getChooseUsers = function(index,call) {
    let actData = new ActData();
    if(actButtonList.buttonMap[parseInt(index)].document.lineJavaScript.needAuditor != true){
        call(false);
    }
    let auditorMap = actButtonList.buttonMap[parseInt(index)].document.lineJavaScript.auditorMap;
    //如果是指定人中选一个的，则列出人的列表
    if(auditorMap.FORM_SERVICE_USERS.length > 0){
        call(auditorMap.FORM_SERVICE_USERS);
    }else if(auditorMap.FORM_SERVICE_GROUP.length > 0  && auditorMap.FORM_SERVICE_ROLE.length < 1){    //只选择部门
        call(actData.getUser({
            group:auditorMap.FORM_SERVICE_GROUP
        }));
    }else if(auditorMap.FORM_SERVICE_ROLE.length > 0 && auditorMap.FORM_SERVICE_GROUP.length < 1){     //只选择角色
        call(actData.getUser({
            role :auditorMap.FORM_SERVICE_ROLE
        }));
    }else if(auditorMap.FORM_SERVICE_GROUP && auditorMap.FORM_SERVICE_ROLE){      //选择角色和部门
        call(false);
    }
};

//加载按钮配置
ActButton.prototype.loadButtonList = function(pram,call){
    actButton.post(loadButtonListUrl,pram,function(data){
        if(data && data.length > 0 ){
            actButtonList = new ActButtonList(data);
            if(typeof call == 'function'){
                call(actButtonList);
            }
        }else{
            if(typeof call == 'function'){
                call(false);
            }
        }
    });

}


ActButton.prototype.actButtonClick = function(index) {



    actForm.values = {};
    actForm.users = {};
    if (typeof win._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS != "undefind")
        win._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = null;
    //从按钮列表中获取按钮配置
    let actButtonJson = actButtonList.buttonMap[index];
    //初始化当前按钮对象
    actButton.overflowAttr(actButtonJson);
    actData.buttionClickId = index;
    try {
        let isCall = false;
        //获取前置处理js方法集合
        let functionNames = actButtonList.buttonConfigList[index].document.lineJavaScript.otherJs;
        let funArray = functionNames.split(",");
        if (functionNames && functionNames.length > 0 && funArray && funArray.length > 0) {
            //方法返回值状态
            let flag = true;
            for (let i = 0; i < funArray.length; i++) {
                let functionName = funArray[i];
                if (typeof (eval(actButton[functionName])) == "function") {
                    if (functionName.indexOf("call") == 0)
                        isCall = true;
                    //根据函数名得到函数类型
                    let func = eval(actButton[functionName]);
                    //创建函数对象，并调用
                    func(function (type, call) {
                        //如果调用的方法返回的不是对象，那么返回值会是方法本身，故无法判断方法是否正确执行，默认放行。
                        // 返回对象的默认格式 {status : false || true ,msg: ""}
                        if (typeof (type) != "object" && typeof (type) != "function") {
                            if (type == true) {
                                console.log("前置处理程序执行成功：方法名称" + functionName);
                                if (typeof call == 'function')
                                    call();
                            }
                        } else if (typeof (type) == "object" && (type.status == true || type.status == "true")) {
                            console.log("前置处理程序执行成功：方法名称" + functionName);
                            if (typeof call == 'function')
                                call();
                        } else if (typeof (type) == "object" && (type.status != true && type.status != "true" && type.msg)) {
                            actButton.closeAll();
                            win.layer.alert(type.msg, {icon: 2});
                            flag = false;
                        } else {
                            actButton.closeAll();
                            win.layer.alert("执行流程推进前置处理程序出错!推进中断，当前信息已保存。" + ("<br>错误信息:" + type.msg) || ("<br>出错方法:" + functionName));
                            flag = false;
                        }
                    }, function () {
                        clickButtonId = actData.buttionClickId;
                        actButton.load();
                        actButton.buttonClick(clickButtonId);
                    }, index);
                } else {
                    console.log("未找到方法：" + functionName + "，流程推进可能出错")
                }
            }
            if (!flag) {
                actButton.closeAll();
                return false;
            }
        }
        if (!isCall) {
            clickButtonId = actData.buttionClickId;
            actButton.load();
            actButton.buttonClick(clickButtonId);
        }
    } catch (e) {
        console.log(e.stack);
        actButton.closeAll();
        win.layer.alert("推进出错！" + e.message);
        return false;
        //actButton.buttonClick($(this).attr("id"));
    }
    return false;
}

ActButton.prototype.showButtonList = function(showListCall){
    let buttonList = actButtonList.buttonConfigList;
    if( typeof showListCall == "function"){
        showListCall(buttonList);
    }else{
        for(let item in buttonList ) {

            let htmlTemp = "<button id=\""+item+"\" type='button' class='actButton "+actButton.style.class+"' >"+buttonList[item].name+"</button>";
            if(!buttonList[item].document){
                htmlTemp = "<button id=\""+item+"\" style='display: none;' type='button' class='actButton "+actButton.style.class+"' >"+buttonList[item].name+"</button>";
            }
            //按钮是否有显示前置方法
            if(buttonList[item].document && buttonList[item].document.lineJavaScript.afterButtonShow){
                let funName = buttonList[item].document.lineJavaScript.afterButtonShow;
                if(this.isFunction(funName))
                {
                    let  func=eval(funName);
                    new func(htmlTemp,function(res){
                        if(res == true || res == "true"){
                            $("#" + actData.docId).append(htmlTemp);
                        }else if(typeof res == "string"){
                            $("#" + actData.docId).append(res);
                        }
                    });
                }else{
                    $("#" + actData.docId).append(htmlTemp);
                }
            }else{
                $("#" + actData.docId).append(htmlTemp);
            }
        }
    }
    $(".actButton").click(function () {
        return actButton.actButtonClick(this);
    });
}


//获取待办列表
ActButton.prototype.todoList = function(prams,call){
    if(prams == undefined || prams == null){
        prams = {};
    }
    if(!actProcess.deploymentKey){
        actButton.init(function(){
            prams.deploymentKey = actProcess.deploymentKey;
            actButton.post(actTodoListUrl,JSON.stringify(prams),function (todoList) {
                if(typeof call == 'function'){
                    call(todoList);
                }
            });
        })
    }else {
        prams.deploymentKey = actProcess.deploymentKey;
        actButton.post(actTodoListUrl,JSON.stringify(prams),function (todoList) {
            if(typeof call == 'function'){
                call(todoList);
            }
        });
    }

}

//获取待办列表
ActButton.prototype.todoAllList = function(prams,callBack){
    if(prams == undefined || prams == null){
        prams = {};
    }
    prams.deploymentKey = actProcess.deploymentKey;
    if(callBack != undefined  &&  typeof callBack == "function"){
        actButton.postAsync(actTodoAllListUrl,JSON.stringify(prams),callBack);
    }
    else{
        let todoList = actButton.post(actTodoAllListUrl,JSON.stringify(prams));
        return todoList;
    }
}

//获取我已审核列表
ActButton.prototype.examinedList = function(prams,call){
    if(prams == undefined || prams == null){
        prams = {};
    }
    if(!actProcess.deploymentKey) {
        actButton.init(function () {
            prams.deploymentKey = actProcess.deploymentKey;
            actButton.post(actExaminedUrl,JSON.stringify(prams),function(examinedList){
                if(typeof call == 'function'){
                    call(examinedList);
                }
            });
        });
    }else{
        prams.deploymentKey = actProcess.deploymentKey;
        actButton.post(actExaminedUrl,JSON.stringify(prams),function(examinedList){
            if(typeof call == 'function'){
                call(examinedList);
            }
        });
    }

}


//根据按钮id 获取deploymentkey
ActButton.prototype.getDeploymentKey = function(buttonId,call){
    actButton.post(actButtonConfig,{id:buttonId},function(requestData){
        //设置流程key
        actProcess.deploymentKey = requestData.deploymentkey;
        if(typeof call == 'function'){
            call(requestData);
        }
    });

}


ActButton.prototype.getActServiceDataById = function(serviceId,call){
    actButton.post(getActServiceDataByIdUrl,{deploymentKey:actProcess.deploymentKey,serviceId:serviceId},function(data){
        if(typeof call == 'function'){
            call(data);
        }
    });
}

ActButton.prototype.terminate = function(processInstanceId,call){
    if(!processInstanceId && actForm && actForm.processInstanceId)
        processInstanceId = actForm.processInstanceId;
    actButton.post(terminateUrl,{processInstanceId:processInstanceId,deleteReason:""},function(data){
        if(typeof call == 'function'){
            if(data.code == 200){
                call(true);
            }else{
                win.layer.alert("流程提前结束失败：" + data.msg, {icon: 2,closeBtn: 0 });
                call(false);
            }
        }
    });
};


ActButton.prototype.init = function(call,serviceId,showListCall){
    //根据id判断是否新流程
    let processInstanceId = getQueryVariable("processInstanceId");
    if(processInstanceId){
        actData.id = processInstanceId;
        actForm.processInstanceId = processInstanceId;
    }
    //根据业务配置信息获取流程定义
    if(actData.buttonId != undefined && actData.buttonId != null ){
        actButton.getDeploymentKey(actData.buttonId,function(){
            //根据流程定义加载按钮
            if(serviceId && serviceId > 0 && !processInstanceId){
                actButton.getActServiceDataById(serviceId,function (res) {
                    if(res && res._ProcessInstanceId){
                        isStart = false;
                        actData.id = res._ProcessInstanceId;
                        actForm.processInstanceId = res._ProcessInstanceId;
                        actProcess.processInstanceId = res._ProcessInstanceId;
                    }
                    actButton.loadButtonList(actProcess,function(data){
                        if(data){
                            actButton.showButtonList(showListCall);
                        }else {
                            showListCall([]);
                        }
                        if(typeof call == 'function'){
                            call();
                        }
                    })
                })
            }else{
                actButton.loadButtonList(actProcess,function(data){
                    if(data){
                        actButton.showButtonList(showListCall);
                    }
                    if(typeof call == 'function'){
                        call();
                    }
                })
            }
        });
    }
}

ActButton.prototype.getRemarks = function(call){
    //加载审核意见等信息
    if(!actTask.lastId  && actProcess.processInstanceId){
        let taskList = actButton.getTaskList(actProcess.processInstanceId,function(taskList){
            if(taskList && taskList instanceof Array && taskList.length > 0 )
                actTask.lastId = taskList[taskList.length - 1].id;
            actButton.getRemarksFromActTask(call);
        });
    }
    if(actTask.lastId){
        actButton.getRemarksFromActTask(call)
    }
}
ActButton.prototype.getRemarksFromActTask = function (call){
    actButton.getFrom(actTask.lastId,function(thisForm){
        if(thisForm == undefined || thisForm.fields == undefined || thisForm.fields.length == 0)
            return;
        thisForm.fields.forEach(function (item,index) {
            if(item.id == "otherData" && item.value && item.value.length > 0){
                let otherData = JSON.parse(item.value);
                if(otherData != null &&  otherData.hasOwnProperty("remarks")){
                    if(typeof call == "function"){
                        call(actButton.escape(otherData.remarks));
                    }else if(typeof showRemarks == "function"){
                        win.showRemarks(actButton.escape(otherData.remarks));
                    }
                }
            }
        })
    });
}






ActButton.prototype.getTaskFormValueById = function(task,id){
    let value = "";
    task.forEach(function(object,index){
        if(object.id == id){
            value = object.value;
        }
    })
    return value;
}


function getQueryVariable(variable)
{
    let query = window.location.search.substring(1);
    let vars = query.split("&");
    for (let i=0;i<vars.length;i++) {
        let pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
    }
    return(false);
}

ActButton.prototype.isFunction = function(funName){
    if(funName == undefined || funName == "")
        return false;
    if($.isFunction(funName))
        return true;
    if(typeof funName == "string"){
        try{
            if(typeof(eval(funName)) == "function")
                return true;
        }catch(e){
            return false;
        }
    }
    return false;
}

ActButton.prototype.escape = function (t) {
    return String(t || "").replace(/&([a-zA-Z0-9]+;)/g, "&amp;$1").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;")
}

ActButton.prototype.timeFormat = function (time) {
    if(time == null || undefined)
        return "";
    let d = new Date(time);
    let year = d.getFullYear();       //年
    let month = d.getMonth() + 1;     //月
    let day = d.getDate();            //日

    let hh = d.getHours();            //时
    let mm = d.getMinutes();          //分
    let ss = d.getSeconds();           //秒
    let clock = year + "-";
    if (month < 10)
        clock += "0";
    clock += month + "-";
    if (day < 10)
        clock += "0";
    clock += day + " ";
    if (hh < 10)
        clock += "0";
    clock += hh + ":";
    if (mm < 10) clock += '0';
    clock += mm + ":";
    if (ss < 10) clock += '0';
    clock += ss;
    return (clock);
}

